
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "date-picker",
  extends: VuePersianDatetimePicker,
  template: `
  	<div>
    	<button @click="handleClick">Click Me</button>
    </div>
  `,
  mounted() {
    let btnClose = document.createElement("span");
    btnClose.className = `btn-close`;
    btnClose.addEventListener("click", () => {
      this.clearValue();
    });
    btnClose.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 mt-1">
    <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>`;
    this.$el.children[0].append(btnClose);
  },
};
</script>

